// extracted by mini-css-extract-plugin
module.exports = {"dealing":"UserServices_dealing__2fxtB","types":"UserServices_types__33g9F","title":"UserServices_title__29bfw","disabledTab":"UserServices_disabledTab__3TZNq"};